import { ProgressBarComponentCss, ProgressBarComponentHtml } from './ProgressBarComponent.tpl.js';

class ProgressBarComponent extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        // Создаем шаблон для компонента
        const template = document.createElement('template');
        template.innerHTML = `
            <style>${ProgressBarComponentCss}</style>
            ${ProgressBarComponentHtml}
        `;
        this.shadowRoot?.appendChild(template.content.cloneNode(true));
        this.bar = this.shadowRoot?.querySelector('.progress-bar');
    }
    connectedCallback() {
        this.setAttribute('role', 'progressbar');
        this.setAttribute('aria-valuemin', '0');
        this.setAttribute('aria-valuemax', '100');
        this.setAttribute('aria-valuenow', '0');
    }
    disconnectedCallback() {
    }
    set valueProgress(value) {
        const safeValue = Math.max(0, Math.min(value, 100));
        this.setAttribute('value', safeValue.toString());
        this.bar.style.width = `${safeValue}%`;
        this.setAttribute('aria-valuenow', safeValue.toString());
    }
    get valueProgress() {
        return parseFloat(this.getAttribute('value') || '0');
    }
    static get observedAttributes() {
        return ['value'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'value' && oldValue !== newValue) {
            const numValue = parseFloat(newValue);
            if (!isNaN(numValue)) {
                this.valueProgress = numValue;
            }
        }
    }
}

export { ProgressBarComponent };
